module.exports = __webpack_public_path__ + "static/media/buy_req_help_11.2b07a7b3.png";